import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import React from 'react';
import { resolveObj } from './dgObject.mjs';

var resource = {}; // This variable will hold the fetched content

var propsFnPreFetch = function propsFnPreFetch(Component, functionName, functionParams, config) {
  return function (props) {
    // Initiate the id which will be used to store the result of the fetch operation
    var fetchedId = "".concat(functionName); // Check if the data needs to be fetched or if it is already present
    // Examine all of the prop parameters

    var propParamsExpanded = functionParams.map(function (param) {
      if (typeof param === "string" && param.includes("props.")) {
        return resolveObj(param.split(".").slice(1).join("."), props);
      } else {
        return param;
      }
    }); // Append on the stringified version of all props supplied to the object key in order to uniquely identify it

    fetchedId += JSON.stringify(propParamsExpanded, function (key, value) {
      // Want to eliminate any keys from the object which will change every time and hence prevent matching
      // Check if key matches the string "key"and  if matched return value "undefined"
      if (key === "key" || key === "_context") {
        return undefined;
      } // else return the value itself


      return value;
    }); // Update the id
    // Run the fetching function

    if (!(fetchedId in resource)) {
      resource[fetchedId] = wrapPromise(props[functionName].apply(props, _toConsumableArray(propParamsExpanded))); // Record the function call in the resource object to log that the fetch has already taken place
      // Set a timeout period

      if (config !== null && config !== void 0 && config.timeoutPeriod) {
        setTimeout(function () {
          delete resource[fetchedId];
        }, config.timeoutPeriod);
      }
    } // Try and read the result of the function which was just run
    // If the promise has not yet resolved, then the read() method below will
    // set this component in to suspended mode until the promise has been completed


    var resourceData = resource[fetchedId].read(); // Update the props to add in the new resource which is attribiuted with the respsonse from the call

    var newProps = Object.assign({}, props, {
      dgPreProps: resourceData
    }); // Pass these updated props which contain the result of the function call to the original wrapped component

    return /*#__PURE__*/React.createElement(Component, newProps);
  };
}; // Function to wrap the promise which we are sending and to suspend all further rendering until the data is ready

function wrapPromise(promise) {
  var status = "pending";
  var result;
  var suspender = promise.then(function (r) {
    status = "success";
    result = r;
  }, function (e) {
    status = "error";
    result = e;
  });
  return {
    read: function read() {
      if (status === "pending") {
        throw suspender;
      } else if (status === "error") {
        throw result;
      } else if (status === "success") {
        return result;
      }
    }
  };
}

export { propsFnPreFetch as default, propsFnPreFetch };
